var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenuBook = function SvgIconMenuBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 6,
    width: 22,
    height: 15,
    rx: 2,
    fill: "#fff",
    stroke: "#343637",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.1,
    y: 4,
    width: 8,
    height: 14,
    rx: 1,
    fill: "#fff",
    stroke: "#343637",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 4,
    width: 8,
    height: 14,
    rx: 1,
    fill: "#fff",
    stroke: "#343637",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 7h2",
    stroke: "#343637",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconMenuBook;